<div class="emission-dialog">
  <div class="bg-glow bg-glow-1"></div>
  <div class="bg-glow bg-glow-2"></div>

  <header class="dialog-header">
    <div class="title-block">
      <div class="icon-box">
        <mat-icon>eco</mat-icon>
      </div>
      <div>
        <h2>Emission Onboarding</h2>
        <p *ngIf="data?.vesselName">
          {{ data?.vesselName }}
          <span *ngIf="data?.imoNumber">· IMO {{ data?.imoNumber }}</span>
        </p>
        <p *ngIf="!data?.vesselName">
          Complete emission parameters for vessel onboarding
        </p>
      </div>
    </div>
    <button type="button" class="icon-close" (click)="closePopup()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="emissionForm" (ngSubmit)="submitEmissionDetails($event)" class="dialog-body" novalidate>
    <section class="form-section">
      <div class="section-heading">
        <mat-icon>speed</mat-icon>
        <h3>Main Engine Performance</h3>
      </div>
      <div class="field-grid">
        <div class="field-group" *ngFor="let field of requiredEmissionFields">
          <label>{{ field.label }}</label>
          <input [type]="field.key === 'fuelTypeMe' ? 'text' : 'number'" class="form-control"
            [class.is-invalid]="showFieldError(field.key)" [placeholder]="field.label" [formControlName]="field.key" />
          <span class="field-error" *ngIf="showFieldError(field.key)">Required</span>
        </div>
        <div class="field-group">
          <label>Cfme</label>
          <input type="number" class="form-control" placeholder="Cfme" formControlName="cfme" />
        </div>
        <div class="field-group">
          <label>SFCme (g/kWh)</label>
          <input type="number" class="form-control" placeholder="SFCme (g/kWh)" formControlName="sfcme" />
        </div>
        <div class="field-group">
          <label>SFCme, Lim (g/kWh)</label>
          <input type="number" class="form-control" placeholder="SFCme, Lim (g/kWh)" formControlName="sfcmeLim" />
        </div>
      </div>
    </section>

    <section class="form-section">
      <div class="section-heading">
        <mat-icon>bolt</mat-icon>
        <h3>Auxiliary Engine</h3>
      </div>
      <div class="field-grid">
        <div class="field-group">
          <label>Pae (kW)</label>
          <input type="number" class="form-control" placeholder="Pae (kW)" formControlName="pae" />
        </div>
        <div class="field-group">
          <label>Type of Fuel (AE)</label>
          <input type="text" class="form-control" placeholder="Type of Fuel (AE)" formControlName="fuelTypeAe" />
        </div>
        <div class="field-group">
          <label>CF ae</label>
          <input type="number" class="form-control" placeholder="CF ae" formControlName="cfae" />
        </div>
        <div class="field-group">
          <label>SFE ae (g/kWh)</label>
          <input type="number" class="form-control" placeholder="SFE ae (g/kWh)" formControlName="sfeae" />
        </div>
        <div class="field-group">
          <label>ICE Class</label>
          <input type="text" class="form-control" placeholder="ICE Class" formControlName="iceClass" />
        </div>
      </div>
    </section>

    <section class="form-section">
      <div class="section-heading">
        <mat-icon>tune</mat-icon>
        <h3>Correction Factors</h3>
      </div>
      <div class="field-grid">
        <div class="field-group">
          <label>fi</label>
          <input type="number" class="form-control" placeholder="fi" formControlName="fi" />
        </div>
        <div class="field-group">
          <label>fc</label>
          <input type="number" class="form-control" placeholder="fc" formControlName="fc" />
        </div>
        <div class="field-group">
          <label>fj</label>
          <input type="number" class="form-control" placeholder="fj" formControlName="fj" />
        </div>
        <div class="field-group">
          <label>fw</label>
          <input type="number" class="form-control" placeholder="fw" formControlName="fw" />
        </div>
        <div class="field-group">
          <label>fm</label>
          <input type="number" class="form-control" placeholder="fm" formControlName="fm" />
        </div>
        <div class="field-group">
          <label>fivse</label>
          <input type="number" class="form-control" placeholder="ficsr" formControlName="ficsr" />
        </div>
      </div>
    </section>

    <footer class="dialog-footer">
      <button type="button" class="btn-secondary" (click)="closePopup()">Cancel</button>
      <button type="submit" class="btn-primary">
        <mat-icon>check_circle</mat-icon>
        Submit Emission Details
      </button>
    </footer>
  </form>
</div>